
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Divider, Pagination, Tooltip } from "antd";

import CreateReport from '../EachAccount/eachaccount';

import "./account.scss";

class Account extends Component{
    constructor(props) {
        super(props)

        let accountList=[
            {
                accountName:'CBS',
                totalUsage: '100 GB',
                totalCost: '$42',
                creationDate: '07/03/2019',
                status: 'Active',
                userList: '2'
            },
            {
                accountName:'FOX',
                totalUsage: '400 GB',
                totalCost: '$10',
                creationDate: '08/23/2019',
                status: 'Deactivate',
                userList: '8'
            },
            {
                accountName:'CloudFlyer',
                totalUsage: '5 GB',
                totalCost: '$11',
                creationDate: '09/12/2000',
                status: 'Active',
                userList: '7'
            },

        ];
        this.state = {
            accountList: accountList,
        }

    }
    render(){
        const AccountTableHeader = <ul>
                                    <li>Account Name</li>
                                    <li>Total Usage<span className="subtitle">Previous month</span></li>
                                    <li>Total Cost<span className="subtitle">Previous month</span></li>
                                    <li>Creation date</li>
                                    <li>Status</li>
                                    <li>
                                        <Tooltip title="Number of Users">
                                            <span className="users-tooltip">Users</span>
                                        </Tooltip>
                                    </li>
                                    <li>Detail</li>
                                </ul>

        const ReportList = this.state.accountList.map((rl,index)=>{
            return(
                <div>
                    <Divider/>
                    <CreateReport 
                        key = {index}
                        accountName = {rl.accountName}
                        totalUsage = {rl.totalUsage}
                        totalCost = {rl.totalCost}
                        creationDate = {rl.creationDate}
                        status = {rl.status}
                        userList = {rl.userList}
                    />
                </div>
            )
        })
        return(
            <div className="account-wrapper">
                <div className="header">
                    <h3 className="title-left">Account</h3>
                    <h3 className="title-right">Download Report</h3>
                </div>
                <div className="table-header">
                    {AccountTableHeader}
                </div>
                <div>
                    {ReportList}
                </div>
                <Divider/>
                <div className="page-pagination">
                    <Pagination size="small" total={500} defaultPageSize={10}/>
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(Account)
  );